import { render, staticRenderFns } from "./BannerTypes.vue?vue&type=template&id=2e788e12"
import script from "./BannerTypes.vue?vue&type=script&lang=js"
export * from "./BannerTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports